import {
	getToken,
	setToken,
	removeToken,
	getUser,
	setUser,
	removeUser
} from '@/utils/auth.js';
const user = {
	namespaced: true,
	state: {
		token: getToken() || null,
		user: getUser() || null,
	},
	// 专门用来读取state数据，相当于仓库的“查询接口”
	getters: {
		// 获取token  使用store.getters['user/getUserToken']
		getUserToken(state) {
			return state.token
		},
		// 获取user  使用store.getters['user/getUser']
		getUser(state) {
			return state.user
		},
	},
	mutations: {
		// 保存token，同步更新vuex和本地缓存
		SET_TOKEN(state, tokenStr) {
			state.token = tokenStr
			setToken(tokenStr)
		},
		// 清空token，退出登录使用
		CLEAR_TOKEN(state) {
			state.token = null
			removeToken()
		},
		
		
		// 保存user，同步更新vuex和本地缓存
		SET_USER(state, userStr) {
			state.user = userStr
			setUser(userStr)
		},
		// 清空user，退出登录使用
		CLEAR_USER(state) {
			state.user = null
			removeUser()
		},
	},
	actions: {
		// 登录保存token
		saveToken({
			commit
		}, tokenStr) {
			commit('SET_TOKEN', tokenStr)
		},
		// 退出登录清空token
		logout({
			commit
		}) {
			commit('CLEAR_TOKEN')
		},
		// 登录保存user
		saveUser({commit},userStr) {
			commit('SET_USER',userStr)
		},
		// 退出登录清空user
		logoutUser({
			commit
		}) {
			commit('CLEAR_USER')
		},
		
	}
}



export default user